import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import IMultiSelect from '../../../components/text-component/multiselect/i-multiselect.component';
import IForm from '../../../components/i-form/i-form.component';

const DependencyFormComponent = (props: any) => {
  const [dependencyData, setDependencyData] = useState<any>({dependency:[]});
  const [dependencyValues, setDependencyValues] = useState<string[]>();
  const [message, setMessage] = useState('');

  useEffect(() => {
    setDependencyData(props.data);
    setDependencyValues(props.dependencyValues);
  }, []);

  function getSerial(array: any) {
    let dependencyArray = [];
    for(let i = 0; i < array.length; ++i) {
      if('NA' === array[i]) {
        dependencyArray.push('NA');
      } else {
        dependencyArray.push(array[i].split(" - ")[0].trim());
      }
    }

    return dependencyArray;
  }

  const onSubmit = (data: any) => {
    let array: string[] = getSerial(data.dependency);
    let value = true;
    if(array.includes('NA') && array.length > 1) {
      value = false;
    } else {
      for(let i = 0; i < array.length && array[i] !== 'NA'; ++i) {
        if(props.data.serial >= array[i].valueOf()) {
          value = false;
          break;
        }
      }
    }
    
    if(value) {
      props.data.dependency = array;
      props.close();
    } else {
      setMessage('Incorrect dependencies');
    }
  }

  const onCancel = () => {
    props.close();
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} width={350}>
      <Grid xs={12} sx={{marginTop: -1, marginLeft: 10, color: 'red', fontWeight: 'bold'}}> {<label> {message}</label>} </Grid>
      <Grid xs={12}>
        <IMultiSelect name='dependency' label='Dependency' itemList={dependencyValues} required={true}/>
      </Grid>
    </Grid>
  }

  return <IForm formData={dependencyData} cancelNavigation={false} cancelForm={onCancel}
          submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default DependencyFormComponent;